<template>
  <div class="container">
    <div id="BlankTemplate" v-if="this.$route.meta.layout == 'BlankTemplate'">
      <router-view />
    </div>
    <div v-else>
      <br />
      <div v-if="token != 'satyagraha'">
        Token: <input type="password" v-model="token" />
      </div>

      <div v-if="token == 'satyagraha'">
        <div class="row p-2 logodiv su-cerceve">
          <div class="glass_card">
            <h1>SentiSolv</h1>
          </div>

          <!-- <img src="@/assets/img/logosmall.png" alt="" width="270" /> -->
          <router-link to="/">&nbsp;Home</router-link>
        </div>

        <router-view />
      </div>
      <div v-else>Type your token please</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: "satyagraha",
    };
  },
};
</script>
<style lang="css">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&display=swap");

body {
  font-family: "Inter", sans-serif !important;
}

.su-cerceve {
  border-radius: 10px;
  padding: 1em;
  margin: 21px 0px 0px 5px;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.su-h400 {
  height: 400px;
}

.su-h500 {
  height: 500px;
}

.widget {
  overflow-y: auto;
  overflow-x: hide;
}

.logodiv {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #151415;
  background: -webkit-linear-gradient(to right, #333399, #1e0218);
  background: linear-gradient(to right, #333399, #ff002f);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
}
.logodiv a {
  color: white;
}

.nav {
  background-color: #da074d;
}
.nav a {
  color: rgb(109, 16, 16);
}
.nav a:visited {
  color: #da074d;
}

.glass_card {
  background: white;
  background: linear-gradient(
    to right bottom,
    rgba(255, 255, 255, 0.4),
    rgba(255, 255, 255, 0.2)
  );
  backdrop-filter: blur(1rem);
  width: 20%;
  height: 40%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5rem;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
}

.glass-card h1 {
  font-size: 5rem;
  color: white;
  text-align: center;

  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5rem;
  text-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
}
.rowtitle {
  font-size: small;
  font-weight: bold;
  color: #da074d;
}
</style>
